import React from 'react';
import { Route, Switch } from 'react-router-dom';
import SecondaryUploadForm from '../../../SecondaryUpload/UploadForm/index.jsx';
import SecondaryViewForm from '../../../SecondaryUpload/ViewForm/index.jsx';
import SecondaryViewTab from '../../../SecondaryUpload/ViewTab/index.jsx';
import SecondaryCreateGroupForm from '../../../SecondaryUpload/CreateGroupForm/index.jsx';
import SecondaryDashboardForm from '../../../SecondaryUpload/DashboardForm/index.jsx';
import SecondaryCreateVanForm from '../../../SecondaryUpload/CreateVanPlanning/index.jsx';


import SecondaryViewGroupForm from '../../../SecondaryUpload/ViewGroupForm/index.jsx';
import SecondaryErrorReport from '../../../SecondaryUpload/DownloadErrorReport/index.jsx';
import PackingOrderView from '../../../SecondaryUpload/PackingOrderView/index.jsx';
import SecondaryViewTaskForm from '../../../SecondaryUpload/ViewTaskForm/index.jsx';
import PackingDashboadView from '../../../SecondaryUpload/PackingDashboardView/index.jsx';
import PartyPackedView from '../../../SecondaryUpload/Party/index.jsx';
import SecondaryVanDashboardForm from '../../../SecondaryUpload/VanDashboardForm/index.jsx';
import BillNumberUpload from '../../../SecondaryUpload/BillNumberUpload/index.jsx';
import BillNumberReUpload from '../../../SecondaryUpload/BillNumberReUpload/index.jsx';
import BillByPass from '../../../SecondaryUpload/BillByPass/index.jsx';
import PTLtoPackingApp from '../../../SecondaryUpload/PTLtoPackingApp/index.jsx';


import CreateMasterPTL from '../../../SecondaryUpload/CreateMasterPTL/index.jsx';
import CreatePTL from '../../../SecondaryUpload/CreatePTL/index.jsx';
import ManualPTL from '../../../SecondaryUpload/ManualPTL/index.jsx';
import EditPTL from '../../../SecondaryUpload/EditPTL/index.jsx';
import DispatchConfirm from '../../../SecondaryUpload/DispatchConfirm/index.jsx';
import ManualHandover from '../../../SecondaryUpload/ManualHandover/index.jsx';
import TripPlanning from '../../../SecondaryUpload/TripPlanning/index.jsx';
import CldLooseConfirm from '../../../SecondaryUpload/CldLooseConfirm/index.jsx';
import BillVSOPCVanReport from '../../../SecondaryUpload/BillVSOPCVanReport/index.jsx';
import SODispatchReport from '../../../SecondaryUpload/SODispatchReport/index.jsx';
import SOToDispatchReport from '../../../SecondaryUpload/SOToDispatchReport/index.jsx';



import DispatchConfirmReport from '../../../SecondaryUpload/DispatchConfirmReport/index.jsx';

import PackingTaskReport from '../../../SecondaryUpload/PackingTaskDataReport/index.jsx';
import MasterPackingTaskReport from '../../../SecondaryUpload/MasterPackingTaskDataReport/index.jsx';

import PartyPackedReport from '../../../SecondaryUpload/PartyPackedReport/index.jsx';
import MasterPtlDataReport from '../../../SecondaryUpload/MasterPtlDataReport/index.jsx';
import PtlDataReport from '../../../SecondaryUpload/PtlDataReport/index.jsx';
import CompletedVansReport from '../../../SecondaryUpload/CompletedVansReport/index.jsx';
import BillEditingReport from '../../../SecondaryUpload/BillEditingReport/index.jsx';

import PTLByPass from '../../../SecondaryUpload/PTLByPass/index.jsx';
import BillWisePicksheet from '../../../SecondaryUpload/BillWisePicksheet/index.jsx';
import DRSBoxIdReport from '../../../SecondaryUpload/DRSBoxIdReport/index.jsx';
import DRSCLDReport from '../../../SecondaryUpload/DRSCLDReport/index.jsx';

import UpdateEan from '../../../SecondaryUpload/UpdateEan/index.jsx';
import BillDataDasboard from '../../../SecondaryUpload/BillDataDashboard/index.jsx';
import BillDataDasboardNew from '../../../SecondaryUpload/BillDataDashboardNew/index.jsx';





import PackingStationZoneReport from '../../../SecondaryUpload/PackingStationZoneReport/index.jsx';
import PackingStationOrderReport from '../../../SecondaryUpload/PackingStationOrderReport/index.jsx';
import PTLIncrementalReport from '../../../SecondaryUpload/PTLIncrementalReport/index.jsx';
import PTLCompleteDataReport from '../../../SecondaryUpload/PTLCompeletDataRecord/index.jsx';
import PtlApiPutQtyReport from '../../../SecondaryUpload/PtlApiPutQtyReport/index.jsx';















export default () => (
  <Switch>
    <Route path="/secondaryupload/upload" component={SecondaryUploadForm} />
    <Route path="/secondaryupload/view" component={SecondaryViewForm} />
    <Route path="/secondaryupload/view_task" component={SecondaryViewTab} />
    <Route path="/secondaryupload/create_group" component={SecondaryCreateGroupForm} /> 
    <Route path="/secondaryupload/view_group" component={SecondaryViewGroupForm} /> 
    <Route path="/secondaryupload/dashboard" component={SecondaryDashboardForm} /> 
    <Route path="/secondaryupload/van_dashboard" component={SecondaryVanDashboardForm} /> 
    <Route path="/secondaryupload/error_report" component={SecondaryErrorReport} /> 
    <Route path="/secondaryupload/task_view" component={SecondaryViewTaskForm} /> 
    <Route path="/secondaryupload/task_view" component={SecondaryViewTaskForm} /> 
    <Route path="/secondaryupload/packing_order_view" component={PackingOrderView} /> 
    <Route path="/secondaryupload/packing_dash_view" component={PackingDashboadView} /> 
    <Route path="/secondaryupload/create_van_planning" component={SecondaryCreateVanForm} /> 
    <Route path="/secondaryupload/party_view" component={PartyPackedView} /> 
    <Route path="/secondaryupload/bill_number_upload" component={BillNumberUpload} />
    <Route path="/secondaryupload/bill_number_reupload" component={BillNumberReUpload} />
    <Route path="/secondaryupload/bill_bypass" component={BillByPass} />
    <Route path="/secondaryupload/ptl_to_packing" component={PTLtoPackingApp} />

    <Route path="/secondaryupload/create_master_ptl" component={CreateMasterPTL} />
    <Route path="/secondaryupload/packing_task_report" component={PackingTaskReport} />
    <Route path="/secondaryupload/master_packing_task_report" component={MasterPackingTaskReport} />
    <Route path="/secondaryupload/party_packed_report" component={PartyPackedReport} />
    <Route path="/secondaryupload/master_ptl_data_report" component={MasterPtlDataReport} />
    <Route path="/secondaryupload/ptl_data_report" component={PtlDataReport} />
    <Route path="/secondaryupload/ptl_api_put_qty_report" component={PtlApiPutQtyReport} />
    <Route path="/secondaryupload/zone_master_report" component={PackingStationZoneReport} />
    <Route path="/secondaryupload/order_mapping_report" component={PackingStationOrderReport} />
    <Route path="/secondaryupload/complete_data_report" component={PTLCompleteDataReport} />
    <Route path="/secondaryupload/completed_vans_report" component={CompletedVansReport} />
    <Route path="/secondaryupload/bill_editing_report" component={BillEditingReport} />
     <Route path="/secondaryupload/bill_report" component={BillVSOPCVanReport} />
      <Route path="/secondaryupload/drs_box_id_report" component={DRSBoxIdReport} />
      <Route path="/secondaryupload/drs_cld_report" component={DRSCLDReport} />

     <Route path="/secondaryupload/so_dispatch_report" component={SODispatchReport} />
     <Route path="/secondaryupload/so_to_dispatch" component={SOToDispatchReport} />

     <Route path="/secondaryupload/update_ean" component={UpdateEan} /> 
      <Route path="/secondaryupload/bill_data_dashboard" component={BillDataDasboard} />
      <Route path="/secondaryupload/bill_data_dashboard_new" component={BillDataDasboardNew} />
    <Route path="/secondaryupload/ptl_by_pass" component={PTLByPass} />
    <Route path="/secondaryupload/bill_wise_picksheet" component={BillWisePicksheet} />
    <Route path="/secondaryupload/incremental_data_report" component={PTLIncrementalReport} />
    <Route path="/secondaryupload/create_ptl" component={CreatePTL} />
    <Route path="/secondaryupload/manual_ptl" component={ManualPTL} />
    <Route path="/secondaryupload/edit_ptl" component={EditPTL} />
    <Route path="/secondaryupload/cld_loose_confirm" component={CldLooseConfirm} />

    <Route path="/secondaryupload/dispatch_confirm" component={DispatchConfirm} />
    <Route path="/secondaryupload/manual_handover" component={ManualHandover} />
    <Route path="/secondaryupload/trip_planning" component={TripPlanning} />
    <Route path="/secondaryupload/dispatch_confirm_report" component={DispatchConfirmReport} />














  </Switch>
);
